export default {
  title: {
    add: 'Añadir script',
    update: 'Actualizar script',
  },
  form: {
    strategy: {
      label: 'Estrategia',
      placeholder: 'Seleccionar estrategia',
    },
    source: {
      label: 'Fuente (src)',
      placeholder: 'Introducir fuente',
    },
    async: {
      label: 'Async',
      placeholder: 'Seleccionar async',
    },
    content: {
      label: 'Contenido',
      placeholder: 'Introducir contenido',
    },
  },
  alert: {
    use_case: 'Caso de uso',
  },
  buttons: {
    save: 'Guardar',
  },
};
